import { Search, Bug, Server, ArrowRight } from 'lucide-react';
import ScrollReveal from './ScrollReveal';

const products = [
  {
    icon: Search,
    name: 'Crawler Vision',
    tagline: 'Analysis Platform',
    description: 'Comprehensive SEO and AI readiness analysis. Get your Crawler Vision Score, check LLM visibility, and generate detailed reports.',
    accent: 'bg-cv-navy',
    bg: 'bg-cv-sky/15',
    border: 'border-cv-sky/40',
  },
  {
    icon: Bug,
    name: 'RENDERED Engine',
    tagline: 'Pre-rendering for Bots',
    description: 'Full JavaScript rendering engine that shows you exactly what search engine crawlers see after executing client-side code.',
    accent: 'bg-cv-orange',
    bg: 'bg-cv-gold/15',
    border: 'border-cv-gold/40',
  },
  {
    icon: Server,
    name: 'Utility Server',
    tagline: 'Delivery Infrastructure',
    description: 'High-performance infrastructure powering pre-rendering, report generation, and API delivery worldwide.',
    accent: 'bg-cv-teal',
    bg: 'bg-cv-sky/15',
    border: 'border-cv-sky/40',
  },
];

const EcosystemSection = () => (
  <section className="py-20 md:py-24">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <ScrollReveal>
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-cv-sky/15 text-cv-navy text-xs font-bold uppercase tracking-wider rounded-full border border-cv-sky/30 mb-4">
            Platform Ecosystem
          </span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-cv-navy mb-4">
            Three Products, <span className="text-cv-navy">One Mission</span>
          </h2>
          <p className="text-cv-navy/70 max-w-2xl mx-auto text-lg">
            A unified ecosystem designed to make your website fully discoverable by every bot and AI system that matters.
          </p>
        </div>
      </ScrollReveal>

      <div className="grid lg:grid-cols-3 gap-6">
        {products.map((p, i) => (
          <ScrollReveal key={p.name} delay={i * 0.1}>
            <div className={`relative ${p.bg} border ${p.border} rounded-2xl p-7 h-full hover:shadow-xl transition-all group`}>
              {/* Connector arrow between cards (visible on lg only) */}
              {i < products.length - 1 && (
                <div className="hidden lg:flex absolute -right-3 top-1/2 -translate-y-1/2 z-10 w-6 h-6 bg-white rounded-full shadow-md items-center justify-center border border-cv-navy/15">
                  <ArrowRight className="w-3 h-3 text-cv-navy/40" />
                </div>
              )}

              <div className={`w-12 h-12 rounded-xl ${p.accent} flex items-center justify-center mb-5 cv-emboss group-hover:scale-110 transition-transform`}>
                <p.icon className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-lg font-bold text-cv-navy mb-1">{p.name}</h3>
              <p className="text-xs font-semibold uppercase tracking-wider text-cv-teal mb-3">
                {p.tagline}
              </p>
              <p className="text-sm text-cv-navy/70 leading-relaxed">{p.description}</p>
            </div>
          </ScrollReveal>
        ))}
      </div>
    </div>
  </section>
);

export default EcosystemSection;
